"use client";

function AboutPage(props: { yScroll?: number }) {
  return (
    <div className="full-screen py-24 px-2 md:px-[5%] flex items-center justify-center">
      <div className="container">
        <div className="block md:flex md:justify-center gap-12 mb-4">
          <h1 className="text-2xl text-black font-medium md:w-1/2 lg:w-5/12 xl:w-1/3 h-auto ">
            About Us
          </h1>
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit" />
        </div>
        <div className="block md:flex md:justify-center gap-12">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Our Origins</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              Wilson Wong & Associates traces its roots to 2017 when Wilson Wong
              (current Managing Director) established the firm in Hong Kong,
              specializing in quantity surveying, cost management, and contract
              consultancy.
            </div>
          </div>
          <img
            src="/images/about/1.jpg"
            alt="1"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Strategic Growth & Partnerships</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>Over the years, we have:</div>
              <div>
                • Formed key alliances with industry leaders to enhance our
                service offerings.
              </div>
            </div>
          </div>
          <img
            src="/images/about/2.jpg"
            alt="2"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Today</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              With a team of over 10+ professionals dedicated to delivering
              precision-driven quantity surveying solutions.
            </div>
          </div>
          <img
            src="/images/about/3.jpg"
            alt="3"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
